import { QueryClient } from '@tanstack/react-query';

/**
 * Default configuration for React Query
 */
const defaultOptions = {
  queries: {
    // Time in milliseconds that data is considered fresh
    staleTime: 5 * 60 * 1000, // 5 minutes
    // Time in milliseconds that unused/inactive cache data remains in memory
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
    // Retry failed requests 3 times with exponential backoff
    retry: 3,
    // Retry delay function with exponential backoff
    retryDelay: (attemptIndex: number) =>
      Math.min(1000 * 2 ** attemptIndex, 30000),
    // Refetch on window focus
    refetchOnWindowFocus: false,
    // Refetch on reconnect
    refetchOnReconnect: 'always' as const,
  },
  mutations: {
    // Retry failed mutations once
    retry: 1,
    // Retry delay for mutations
    retryDelay: (attemptIndex: number) =>
      Math.min(1000 * 2 ** attemptIndex, 5000),
  },
};

/**
 * Create and configure the QueryClient instance
 */
export const queryClient = new QueryClient({
  defaultOptions,
});

